'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

exports.default = renderInput;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _reactIntl = require('react-intl');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function renderInput(_ref) {
  var field = _ref.field,
      type = _ref.type,
      labelId = _ref.labelId,
      isLoading = _ref.isLoading;


  var divClass = (0, _classnames2.default)({
    'form-group': true,
    'has-error': field.error && field.touched
  });

  var attrs = (0, _assign2.default)({
    className: 'form-control',
    disabled: isLoading,
    id: field.name
  }, field);

  if ('textarea' !== type) {
    attrs.type = type;
  }

  if ('hidden' === type) {
    return _react2.default.createElement('input', attrs);
  }

  return _react2.default.createElement(
    'div',
    { className: divClass },
    labelId && _react2.default.createElement(
      'label',
      { htmlFor: field.name },
      _react2.default.createElement(_reactIntl.FormattedMessage, { id: labelId })
    ),
    _react2.default.createElement(
      'div',
      { className: 'input-wrap' },
      isLoading && _react2.default.createElement('i', { className: 'fa fa-cog cog' }),
      'textarea' !== type && _react2.default.createElement('input', attrs),
      'textarea' === type && _react2.default.createElement('textarea', attrs),
      field.error && field.touched && _react2.default.createElement(
        'div',
        { className: 'text-danger' },
        field.error
      )
    )
  );
}
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/helpers/renderFormControl.js
 ** module id = 1244
 ** module chunks = 0
 **/